import { EmptyCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/desktop/components/EmptyCard';
import { RotationsplanCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/desktop/components/RotationsplanCard';
import { data } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/desktop/data';

export function Grid() {
  const plaene = data;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {plaene.length < 1 ? (
        <EmptyCard />
      ) : (
        plaene.map((plan) => (
          <RotationsplanCard key={plan.mitarbeiter.id} rotationsplan={plan} />
        ))
      )}
    </div>
  );
}
